import { Link } from 'react-router-dom';
import { BarChart3, History } from 'lucide-react';

const LEFT = [
  { icon: History, label: 'Hands', to: '/hand-history' },
  { icon: BarChart3, label: 'Wallet', to: '/transactions' },
];

/** History / stats shortcuts — centered above the footer on mobile */
export default function MobileSideDock() {
  return (
    <aside className="tp-mobile-dock pointer-events-none xl:hidden" aria-label="Table shortcuts">
      <div className="tp-mobile-dock-inner pointer-events-auto">
        {LEFT.map(({ icon: Icon, label, to }) => (
          <Link
            key={label}
            to={to}
            className="tp-mobile-dock-btn"
            aria-label={label}
            title={label}
          >
            <Icon size={18} strokeWidth={2} />
          </Link>
        ))}
      </div>
    </aside>
  );
}
